import React, { Fragment } from 'react';
import ReactTable from 'react-table';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import {
  Button,
  Divider,
  Form,
  Grid,
  Icon,
  Accordion,
} from 'semantic-ui-react';

import { UPDATE_OPEN_ORDERS_FORM_NAME } from 'Common/FormEnum';
import { UpdateOpenOrdersEnum } from 'Common/FieldEnum';
import { TypeEnum } from 'Common/Constants/Enumeration/UpdateOpenOrderEnum';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import {
  TitledCard,
  NotificationDialog,
  DatePickerCustomButton,
} from 'Components';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { DatePickerField } from 'Common/SemanticWrapper';
import { SelectField } from 'Common/SemanticWrapper';
import { SiteComponent } from 'Common/SiteComponent';
import { SiteTypeEnum } from 'Common/Constants/Enumeration/SiteTypeEnum';

import 'Styles/pages/utilities/updateopenorders/index.less';

const UpdateOpenOrderComponent = props => {
  const {
    openOrderDetailData,
    onSubmit,
    viewTypeOptions,
    siteGroupsOptions,
    warehouseKitchenData,
    itemList,
    loading,
    isFetchingItemList,
    isFetchingSiteGroup,
    columns,
    isTypeOptionSelected,
    itemOptions,
    typeOptionChange,
    onChangeOfToDT,
    onChangeOfSelectDropDown,
    setItemToBeRemoved,
    setItemToBeAdded,
    isTotalExceed,
    onOkClick,
    totalPrimary,
    totalSecondary,
    totalRemaining,
    unitValue,
    secondaryUnitValue,
    qtyPerUnit,
    clearFilters,
    itemsToBeRemoved,
    itemsToBeAdded,
    removeItemSecUnit,
    removeItemPriUnit,
    removeItemQtyPerUnit,
    activeIndexForFilter,
    handleClick,
    onChangeOfWarehouseKitchen,
    onSortedChange,
    onFilteredChange,
    sorted,
    filtered,
    reactTableRef,
    kitchenData,
  } = props;
  return (
    <Fragment>
      <Form onSubmit={onSubmit}>
        <Accordion fluid styled>
          <Accordion.Title
            active={!activeIndexForFilter}
            index={0}
            onClick={handleClick}
          >
            <Icon name="dropdown" />
            <span className="text-orange">Filter By</span>
          </Accordion.Title>
          <Accordion.Content active={!activeIndexForFilter}>
            <Grid className="grid-spacing">
              <Grid.Row columns={3}>
                <Grid.Column
                  style={{
                    textTransform: 'uppercase',
                    fontSize: '0.78571429em',
                  }}
                  width={8}
                >
                  <ReduxFormButtonGroup
                    options={viewTypeOptions}
                    type={'button'}
                    formName={UPDATE_OPEN_ORDERS_FORM_NAME}
                    fieldName={UpdateOpenOrdersEnum.TypeOptions}
                    onChange={typeOptionChange}
                    label={'Type'}
                  />
                </Grid.Column>
                <Grid.Column width={4}>
                  <Field
                    component={DatePickerField}
                    customInput={<DatePickerCustomButton />}
                    dateFormat={DATE_FORMAT_FOR_UI}
                    name={UpdateOpenOrdersEnum.DeliveryDT}
                    type={'text'}
                    label={'Delivery Date'}
                    onChange={onChangeOfToDT}
                    dropdownMode={'select'}
                  />
                </Grid.Column>
                <Grid.Column width={4}>
                  {isTypeOptionSelected === TypeEnum.OpenOrders ? (
                    <Field
                      fluid
                      component={SelectField}
                      loading={isFetchingSiteGroup}
                      name={UpdateOpenOrdersEnum.SiteGroup}
                      options={siteGroupsOptions}
                      onChange={onChangeOfSelectDropDown}
                      label={'Site Group'}
                    />
                  ) : isTypeOptionSelected === TypeEnum.OpenReceipts ? (
                    <SiteComponent
                      name={UpdateOpenOrdersEnum.WarehouseKitchen}
                      isForm={true}
                      label={'Warehouse/Kitchens'}
                      siteMasterTypeIds={[
                        SiteTypeEnum.Warehouse,
                        SiteTypeEnum.Kitchen,
                      ]}
                      isAllRequired={false}
                      checkIsLicensed={false}
                      siteOptions={warehouseKitchenData}
                      onChange={onChangeOfWarehouseKitchen}
                    />
                  ) : (
                    <SiteComponent
                      name={UpdateOpenOrdersEnum.Kitchen}
                      isForm={true}
                      label={'Kitchens'}
                      siteMasterTypeIds={[SiteTypeEnum.Kitchen]}
                      isAllRequired={false}
                      checkIsLicensed={false}
                      siteOptions={kitchenData}
                      onChange={onChangeOfWarehouseKitchen}
                    />
                  )}
                </Grid.Column>
              </Grid.Row>
            </Grid>
            <Grid className="grid-spacing">
              <Grid.Row columns={2}>
                <Grid.Column width={13}>
                  <TitledCard title={'Item'}>
                    <Grid className="grid-spacing">
                      <Grid.Row columns={2}>
                        <Grid.Column>
                          <Field
                            fluid
                            label={'ITEM TO BE REMOVED'}
                            component={SelectField}
                            loading={isFetchingItemList}
                            name={UpdateOpenOrdersEnum.RemoveItemListData}
                            options={itemOptions(itemList)}
                            onChange={setItemToBeRemoved}
                          />
                        </Grid.Column>

                        <Grid.Column>
                          <Field
                            fluid
                            label={'ITEM TO BE ADDED'}
                            component={SelectField}
                            loading={isFetchingItemList}
                            name={UpdateOpenOrdersEnum.AddItemListData}
                            options={itemOptions(itemList)}
                            onChange={setItemToBeAdded}
                          />
                        </Grid.Column>
                      </Grid.Row>
                      <Grid.Row columns={2}>
                        <Grid.Column width={8}>
                          {itemsToBeRemoved ? (
                            <label>
                              {removeItemPriUnit}= {removeItemQtyPerUnit}
                              {removeItemSecUnit}
                            </label>
                          ) : null}
                        </Grid.Column>
                        <Grid.Column width={8}>
                          {itemsToBeAdded ? (
                            <label>
                              {unitValue}= {qtyPerUnit}
                              {secondaryUnitValue}
                            </label>
                          ) : null}
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                  </TitledCard>
                </Grid.Column>
                <Grid.Column width={3} style={{ marginTop: 120 }}>
                  <Button
                    fluid
                    content="Clear Filters"
                    onClick={clearFilters}
                    type={'button'}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Accordion.Content>
        </Accordion>
        <Divider horizontal />
        <Grid.Row>
          <Grid.Column>
            <hr />
          </Grid.Column>
        </Grid.Row>
        <Grid>
          <Grid.Row columns={1} className={'remove-spacing'}>
            <Grid.Column>
              <ReactTable
                defaultPageSize={20}
                showPageSizeOptions={true}
                minRows={0}
                data={openOrderDetailData}
                noDatatext={'No rows found'}
                resizable={false}
                className="-striped -highlight modalGrid"
                columns={columns}
                loading={loading}
                onSortedChange={onSortedChange}
                onFilteredChange={onFilteredChange}
                sorted={sorted}
                filtered={filtered}
                ref={reactTableRef}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column align={'right'}>
              {isTypeOptionSelected === TypeEnum.OpenOrders &&
              (totalPrimary || totalSecondary) &&
              itemsToBeAdded ? (
                <label className="text-orange">
                  Running Total :`
                  {totalPrimary} {unitValue} {totalSecondary.toFixed(6)}{' '}
                  {secondaryUnitValue}`
                </label>
              ) : null}
              {isTypeOptionSelected === TypeEnum.OpenReceipts &&
              itemsToBeAdded ? (
                <label className="text-orange">
                  Remaining Quantity :{totalRemaining}
                </label>
              ) : null}
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <NotificationDialog
          title={'Update Open Orders'}
          showDialog={
            isTotalExceed && TypeEnum.OpenReceipts === isTypeOptionSelected
          }
          message={'Added total exceeds available warehouse quantity.'}
          onOkClick={onOkClick}
        />
      </Form>
    </Fragment>
  );
};

UpdateOpenOrderComponent.propTypes = {
  openOrderDetailData: PropTypes.array.isRequired,
  onSubmit: PropTypes.func,
  viewTypeOptions: PropTypes.array.isRequired,
  siteGroupsOptions: PropTypes.array.isRequired,
  warehouseKitchenData: PropTypes.array.isRequired,
  itemList: PropTypes.array.isRequired,
  loading: PropTypes.bool,
  isFetchingItemList: PropTypes.bool,
  isFetchingSiteGroup: PropTypes.bool,
  columns: PropTypes.array.isRequired,
  isTypeOptionSelected: PropTypes.string,
  itemOptions: PropTypes.func,
  typeOptionChange: PropTypes.func,
  onChangeOfToDT: PropTypes.func,
  onChangeOfSelectDropDown: PropTypes.func,
  setItemToBeRemoved: PropTypes.func,
  setItemToBeAdded: PropTypes.func,
  isTotalExceed: PropTypes.bool,
  onOkClick: PropTypes.func,
  totalPrimary: PropTypes.number,
  totalSecondary: PropTypes.number,
  totalRemaining: PropTypes.string,
  unitValue: PropTypes.string,
  secondaryUnitValue: PropTypes.string,
  qtyPerUnit: PropTypes.number,
  clearFilters: PropTypes.func,
  itemsToBeRemoved: PropTypes.bool,
  itemsToBeAdded: PropTypes.bool,
  removeItemSecUnit: PropTypes.string,
  removeItemPriUnit: PropTypes.string,
  removeItemQtyPerUnit: PropTypes.number,
  activeIndexForFilter: PropTypes.number,
  handleClick: PropTypes.func,
  onChangeOfWarehouseKitchen: PropTypes.func,
  onSortedChange: PropTypes.func,
  onFilteredChange: PropTypes.func,
  sorted: PropTypes.array,
  filtered: PropTypes.array,
  reactTableRef: PropTypes.object,
  kitchenData: PropTypes.array,
};

UpdateOpenOrderComponent.defaultProps = {
  onSubmit: () => {},
  loading: false,
  isFetchingItemList: false,
  isFetchingSiteGroup: false,
  isTypeOptionSelected: '',
  itemOptions: () => {},
  typeOptionChange: () => {},
  onChangeOfToDT: () => {},
  onChangeOfSelectDropDown: () => {},
  setItemToBeRemoved: () => {},
  setItemToBeAdded: () => {},
  isTotalExceed: false,
  onOkClick: () => {},
  totalPrimary: 0,
  totalSecondary: 0,
  totalRemaining: '',
  unitValue: '',
  secondaryUnitValue: '',
  qtyPerUnit: 0,
  clearFilters: () => {},
  itemsToBeRemoved: false,
  itemsToBeAdded: false,
  removeItemSecUnit: '',
  removeItemPriUnit: '',
  removeItemQtyPerUnit: 0,
  activeIndexForFilter: 0,
  handleClick: PropTypes.func,
  onChangeOfWarehouseKitchen: () => {},
  onSortedChange: () => {},
  onFilteredChange: () => {},
  sorted: [],
  filtered: [],
  reactTableRef: null,
  kitchenData: [],
};

export default UpdateOpenOrderComponent;



// WEBPACK FOOTER //
// ./src/pages/utilities/updateopenorders/components/UpdateOpenOrder.js